import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Login from './pages/Login';
import AdminDashboard from './pages/AdminDashboard';
import FlowBuilder from './pages/FlowBuilder';
import FlowPreview from './pages/FlowPreview';
import PublicFlow from './pages/PublicFlow';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* Admin Routes */}
            <Route path="/login" element={<Login />} />
            <Route
              path="/admin"
              element={
                <PrivateRoute>
                  <AdminDashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/flows/new"
              element={
                <PrivateRoute>
                  <FlowBuilder />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/flows/:id/edit"
              element={
                <PrivateRoute>
                  <FlowBuilder />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/flows/:id/preview"
              element={
                <PrivateRoute>
                  <FlowPreview />
                </PrivateRoute>
              }
            />
            
            {/* Public Flow Route */}
            <Route path="/:flowName" element={<PublicFlow />} />
            
            {/* Default redirect */}
            <Route path="/" element={<Navigate to="/admin" replace />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
